<script setup lang="ts">
import SpinLoader from '@marketspark/ui/components/SpinLoader';
</script>
<template>
  <SpinLoader />
</template>
